import React from 'react';
import { Box, Tooltip } from '@mui/material';
import { useShell } from '../Layout';

export const EXPORT_LOCKED_TEXT = 'Скачивание отчётов доступно после оплаты тарифа';

// Report downloads are closed in the trial (the server refuses the report builder too).
export const useExportAllowed = () => useShell()?.profile?.export_allowed !== false;

// ExportGate disables a download button in the trial and says why on hover.
const ExportGate = ({ children }) => {
  const allowed = useExportAllowed();
  if (allowed) return children;
  return (
    <Tooltip title={EXPORT_LOCKED_TEXT}>
      <Box component="span" sx={{ display: 'inline-flex' }}>
        {React.cloneElement(children, { disabled: true })}
      </Box>
    </Tooltip>
  );
};

export default ExportGate;
